// extracted by mini-css-extract-plugin
module.exports = {"quoteBox":"quoteBlock_quoteBox_sjQem"};